import styled from 'styled-components';
import chevronForward from './icons/chevron_forward.svg';
import clipboardSvg from './icons/clipboard.svg';

// Brand
import defaultBrandBannerPng from './icons/brand/default-brand-banner.png';
import defaultBrandBannerSvg from './icons/brand/default-brand-banner.svg';
import defaultBrandLogoPng from './icons/brand/default-brand-logo.png';
import defaultBrandLogoSvg from './icons/brand/default-brand-logo.svg';
import loadingGif from './icons/brand/default-brand-logo.svg';
import binSvg from './icons/bin.svg';
import binGreySvg from './icons/binGrey.svg';
import showPasswordSvg from './icons/show-password.svg';
import hidePasswordSvg from './icons/hide-password.svg';
import crossGreySvg from './icons/cross-grey.svg';
import closeSvg from './icons/close.svg';
import crossRedSvg from './icons/cross-red.svg';
import backIcon from './icons/back.svg';
import TrashPromoFlowSvg from './icons/TrashPromoFlow.svg';
import EditPromoFlowSvg from './icons/EditPromoFlow.svg';
import addCircle from './icons/add-circle.svg';
import closedCaptionSvg from './icons/closed_caption.svg';
import closedCaptionDisabledSvg from './icons/closed_caption_disabled.svg';
import favoriteSvg from './icons/favorite.svg';
import favoriteDisabledSvg from './icons/favorite_disabled.svg';
import commentSvg from './icons/comment.svg';
import commentDisabledSvg from './icons/comments_disabled.svg';
import muteIcon from './icons/mute.svg';
import unmuteIcon from './icons/unmute.svg';
import checkCircleSvg from './icons/check-circle.svg';
import notificationSvg from './icons/notification-bell.svg';
import searchSvg from './icons/search.svg';
import markAllAsReadSvg from './icons/mark-as-read.svg';
import bellIconSvg from './icons/bell-icon.svg';
import notificationHeaderFilterSvg from './icons/notificationHeaderFilter.svg';
import billingInstructionIconSvg from './icons/billingInstructionIcon.svg';
import editBluePencilSvg from './icons/editBluePencil.svg';
import chevronUpSvg from './icons/chevronUp.svg';
import closeCircleSvg from './icons/close-circle.svg';
import messageSentSvg from './icons/message-sent.svg';
import messageScheduledSvg from './icons/message-scheduled.svg';
import messageFailedSvg from './icons/message-failed.svg';
import messageUnderCancellationSvg from './icons/message-under-cancellation.svg';
import messageOpenedSvg from './icons/message-opened.svg';

// Icons
export * from './icons/arrow-downward.svg';
export * from './icons/arrow-upward.svg';
export * from './icons/delete.svg';
export * from './icons/female-icon.svg';
export * from './icons/filled-heart.svg';
export * from './icons/hollow-heart.svg';
export * from './icons/male-icon.svg';
export * from './icons/play.svg';
export * from './icons/percent.svg';
export * from './social-media/instagram.svg';
export const s3InflutechIcons = {
  accountCircle:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/account_circle.svg',
  arrowLeft:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/arrow_left.svg',
  arrowRight:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/arrow_right.svg',
  chevronBackward:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/chevron_backward.svg',
  chevronDown:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/chevron_down.svg',
  chevronForward:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/chevron_forward.svg',
  chevronUp:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/chevron_up.svg',
  close:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/close.svg',
  emoticon:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/emoticon.svg',
  Facebook:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/Facebook.svg',
  favorite:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/favorite.svg',
  Google:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/Google.svg',
  key: 'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/key.svg',
  mail: 'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/mail.svg',
  menu: 'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/menu.svg',
  playArrow:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/play_arrow.svg',
  search:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/search.svg',
  sort: 'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/sort.svg',
  visibility:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/influtech_icons/visibility.svg'
};

export const s3InflutechLogos = {
  influtechLogoNegative:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/lua_group_logos/lua-group-logo-negative.svg',
  influtechLogoPositive:
    'https://numu-default-4e56rdyf-content.s3.eu-west-1.amazonaws.com/default-content/lua_group_logos/lua-group-logo-positive.svg'
};

export const Images = {
  chevronForward,
  clipboardSvg,
  defaultBrandBannerPng,
  defaultBrandBannerSvg,
  defaultBrandLogoPng,
  defaultBrandLogoSvg,
  loadingGif,
  binSvg,
  showPasswordSvg,
  hidePasswordSvg,
  binGreySvg,
  crossGreySvg,
  TrashPromoFlowSvg,
  EditPromoFlowSvg,
  muteIcon,
  unmuteIcon,
  crossRedSvg,
  backIcon,
  addCircle,
  closedCaptionSvg,
  closedCaptionDisabledSvg,
  favoriteSvg,
  favoriteDisabledSvg,
  commentSvg,
  commentDisabledSvg,
  checkCircleSvg,
  notificationSvg,
  searchSvg,
  markAllAsReadSvg,
  bellIconSvg,
  notificationHeaderFilterSvg,
  closeSvg,
  billingInstructionIconSvg,
  editBluePencilSvg,
  chevronUpSvg,
  closeCircleSvg,
  messageSentSvg,
  messageScheduledSvg,
  messageFailedSvg,
  messageUnderCancellationSvg,
  messageOpenedSvg
};

// Social Media
export * from './social-media/tiktok.svg';

export const Ellipsis = styled.div`
  width: 3px;
  height: 3px;
  border-radius: 100%;
  margin: 1.8px;
`;
